const PHOTOSHOOT_DEBUG_PREFIX = '[PSH_DEBUG]'
const PHOTOSHOOT_DEBUG_QUERY_PARAM = 'psh_debug'

function shouldLogPhotoshootDebug(): boolean {
  if (process.env.NODE_ENV !== 'production') return true
  try {
    const params = new URLSearchParams(window.location.search)
    return params.get(PHOTOSHOOT_DEBUG_QUERY_PARAM) === '1'
  } catch {
    return false
  }
}

export function photoshootDebugLog(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (!shouldLogPhotoshootDebug()) return
  const payload = {
    event,
    ts: Date.now(),
    path: window.location.pathname,
    search: window.location.search,
    ...(data ?? {}),
  }
  console.log(PHOTOSHOOT_DEBUG_PREFIX, payload)
}
